import { Injectable, EventEmitter, HostListener, OnInit } from '@angular/core';
import { LocalizationService } from '../services/localization.service';
import { Router } from '@angular/router';
import { TransactionsDialog } from '@components/transactions.dialog';
import { FavoriesPipe } from '@app/pipes/favories.pipe';

interface Customer {
  Balance?: string;
  BalanceAmount?: number;
  Bonus?: string;
  BonusAmount?: number;
  UserName?: string;
  CustomerName?: string;
  CustomerSurname?: string;
  Email?: string;
  Symbol?: string;
  LastLoginDate?: Date;
  PhoneNumber?: string;
  BirthDay?: Date;
  CustomerId?: string;
  BranchId?: number;
  IsView?: string;
  IBAN?: string;
  IsContractAccepted?: boolean;
  ContractAcceptedDate?: Date;
  OldCmbetId?: number;
  CreateDate?: Date;
  BranchType?: number;
  IsCashOutInfo?: boolean;
  IsLimitSet?: boolean;
  IsInsic?: boolean;
}

type depositListType = {
  DepositTypeId: number;
  Description: string;
  DescriptionLong: string;
  DescriptionTitle: string;
  IsActive: boolean;
  MaxValue: number;
  MinValue: number;
  PaymentType: string;
  PaymentTypeId: number;
  RiskLevelId: number;
  Title: string;
  DescriptionList: string[];
  paymentMethodId: string;
}[];

type withdrawListType = {
  DepositTypeId: number;
  Description: string;
  DescriptionLong: string;
  DescriptionTitle: string;
  IsActive: boolean;
  MaxValue: number;
  MinValue: number;
  PaymentType: string;
  PaymentTypeId: number;
  RiskLevelId: number;
  ExtensionData: any;
}[];

@Injectable({
  providedIn: 'root',
})
export class UserHelper {
  public customerUser: Customer;
  public isSignedIn: boolean;
  public isNoData = true;
  signInListener: EventEmitter<any> = new EventEmitter();
  transactionsDialogListener: EventEmitter<any> = new EventEmitter();
  ResetDialogListener: EventEmitter<any> = new EventEmitter();

  public favoriedMatches: string[] = [];
  favoriedListener: EventEmitter<any> = new EventEmitter();

  public userInsicStatus = 2;

  unreadMessageCount = 0;
  hasShopAccount: boolean;
  isInsicStatus = true;
  IsLimitSet = true;

  public walletList = [];
  public walletListLoadingListener: EventEmitter<any> = new EventEmitter();
  public emailIsVerified = false;
  public depositList: depositListType = [];

  // todo eski yapı kaldırılcarak
  public depositListListener: EventEmitter<any> = new EventEmitter();

  public withdrawList: withdrawListType = [];
  public withdrawListListener: EventEmitter<any> = new EventEmitter();
  public balanceVisibility: Map<any, boolean> = new Map();

  constructor(private LS: LocalizationService, private _router: Router) {
    this.isSignedIn = false;
    const a = localStorage.getItem('_F');
    if (a != null) {
      this.favoriedMatches = JSON.parse(a);
    }
    this.initializeBalanceVisibility();
  }
  private initializeBalanceVisibility() {
    try {
      const balanceVisibilityString = localStorage.getItem('userBalanceVisibilityPreference');
      const rawBalanceVisibility = localStorage.getItem('userBalanceVisibilityPreference');
      if (rawBalanceVisibility) {
        this.balanceVisibility = new Map(JSON.parse(rawBalanceVisibility));
      }
    } catch (e) {
      console.warn('Error parsing userBalanceVisibilityPreference from local storage. Removing it.');
      localStorage.removeItem('userBalanceVisibilityPreference');
    }
  }

  setUser(userData: any): void {
    if (userData) {
      this.customerUser = userData;
      this.isSignedIn = true;
      this.signInListener.emit(true);
      this.isNoData ? (this.isNoData = false) : null;
    } else {
      this.customerUser = userData;
      this.isSignedIn = false;
      this.signInListener.emit(false);
      this.isNoData ? (this.isNoData = false) : null;
    }
  }

  updateUser(userData: any): void {
    if (userData) {
      this.customerUser = userData;
      this.isSignedIn = true;
      this.isNoData ? (this.isNoData = false) : null;
    }
  }

  userLogOut(): void {
    this.isSignedIn = false;
    this.signInListener.emit(false);
  }

  setMessageCount(count) {
    this.unreadMessageCount = count;
  }

  toogleFavoried(id: string) {
    if (!this.favoriedMatches && this.favoriedMatches.length == 0) {
      const a = localStorage.getItem('_F');
      if (a != null) {
        this.favoriedMatches = JSON.parse(a);
      }
    }

    const selectedMatch = this.favoriedMatches.findIndex(x => x === id);

    if (selectedMatch > -1) {
      this.favoriedMatches.splice(selectedMatch, 1);
    } else {
      this.favoriedMatches.push(id);
    }
    this.favoriedListener.emit(this.favoriedMatches);

    localStorage.setItem('_F', JSON.stringify(this.favoriedMatches));
  }

  reBuildLiveFavoriList(id) {
    const a = localStorage.getItem('_F');
    if (a != null) {
      this.favoriedMatches = JSON.parse(a);
    }

    if (this.favoriedMatches.filter(i => i === id).length > 0) {
      this.favoriedMatches = this.favoriedMatches.filter(i => {
        return i === id;
      });
    } else {
      this.favoriedMatches.splice(this.favoriedMatches.indexOf(id), 1);
    }

    localStorage.setItem('_F', JSON.stringify(this.favoriedMatches));

    const x = new FavoriesPipe();
    x.transform(id);
  }

  setWalletList(x) {
    this.walletList = x;

    if (x && x.length > 0) {
      this.isInsicStatus = x[0].IsInsic == true ? true : false;
    }
    //For Online Wallet
    const result = x.filter(wallet => wallet.BranchType === 1);

    //For Shop Wallet
    const result2 = x.filter(wallet => wallet.BranchType === 0);

    //For Pay3000 Wallet
    const result3 = x.filter(wallet => wallet.BranchType === 2);
    if (result2 && result2.length > 0) {
      this.hasShopAccount = true;
    }
    // if (result && result.length > 0) {
    //   this.emailIsVerified = result[0].IsVerification === true ? true : false;
    // }
  }
  toggleBalanceVisibility(itemId: number): void {
    const isVisible = this.balanceVisibility.get(itemId) ?? true; // Default to true if not set
    this.balanceVisibility.set(itemId, !isVisible);
    localStorage.setItem('userBalanceVisibilityPreference', JSON.stringify(Array.from(this.balanceVisibility)));
  }

  getBalanceVisibility(itemId: number): boolean {
    return this.balanceVisibility.get(itemId) ?? true; // Default to true if not set
  }
}
